import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';
import hotelImage from '../assets/images/home_firs_page.png'; // replace with your actual image path

const AboutSection = ({ language }) => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Detect when the section is in the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`about-section container my-5 ${visible ? 'fade-in' : ''}`}
    >
      <div className="row align-items-center">
        <div className="col-md-5 mb-4 mb-md-0">
          <img
            src={hotelImage}
            alt="Blue Nest Hotel"
            className="img-fluid rounded shadow-sm custom-img"
          />
        </div>
        <div className="col-md-7">
<h6 className="text-uppercase mb-2 about-label" style={{ color: '#2563eb' }}>
  {language === 'en' ? 'About Blue Nest' : 'ስለ ብሉ ኔስት'}
</h6>
<h2 className="about-heading" style={{ color: '#1e3a8a' }}>
  {language === 'en' 
    ? 'Where Comfort Meets Excellence' 
    : 'ምቾት እና ጥራት የሚገናኙበት ቦታ'}
</h2>

<p className="text-secondary about-description">
  {language === 'en'
    ? 'Experience exceptional hospitality at Blue Nest Hotel, perfectly located on Sarbet Road in Addis Ababa. We offer modern accommodations, fine dining, and professional meeting facilities, all designed to exceed your expectations.'
    : 'በአዲስ አበባ ሳርቤት  መንገድ ላይ በሚገኘው ብሉ ኔስት ሆቴል ልዩ እንግዳ ተቀባይነትን ይለማመዱ። ዘመናዊ መኖሪያዎች፣ ጥሩ ምግብ እና ሙያዊ የስብሰባ መሳሪያዎችን እናቀርባለን።'}
</p>
<div className="about-features mt-4">
  <div className="row">
    <div className="col-md-6">
      <div className="feature-item">
        <i className="fas fa-bed feature-icon"></i>
        <span>{language === 'en' ? 'Luxury Rooms' : 'የቅንጦት ክፍሎች'}</span>
      </div>
    </div>
    <div className="col-md-6">
      <div className="feature-item">
        <i className="fas fa-utensils feature-icon"></i>
        <span>{language === 'en' ? 'Fine Dining' : 'ጥሩ ምግብ'}</span>
      </div>
    </div>
    <div className="col-md-6">
      <div className="feature-item">
        <i className="fas fa-briefcase feature-icon"></i>
        <span>{language === 'en' ? 'Business Center' : 'የንግድ ማእከል'}</span>
      </div>
    </div>
    <div className="col-md-6">
      <div className="feature-item">
        <i className="fas fa-concierge-bell feature-icon"></i>
        <span>{language === 'en' ? '24/7 Service' : '24/7 አገልግሎት'}</span>
      </div>
    </div>
  </div>
</div>
<div className="text-center">
  <Link to="/about">
    <button className="btn btn-about-section mt-3">
      {language === 'en' ? 'Read More' : 'ተጨማሪ ያንብቡ'}
    </button>
  </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
